<template>
  <div class="mantenimiento" v-if="mantenimiento">
    <h1>We&rsquo;ll be back soon!</h1>
    <div>
        <p>Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. If you need to you can always <a href="mailto:ewitte@srk.com.ar">contact us</a>, otherwise we&rsquo;ll be back online shortly!</p>
        <p>&mdash;appSRK Developer Team</p>
    </div>
  </div>

  <!-- Vista de autenticación sin sidebar ni header -->
  <div class="auth-container" v-else-if="isAuthRoute">
    <router-view></router-view>
  </div>

  <!-- Vista principal: sidebar + header + contenido -->
  <div class="main" v-else>
    <SidebarView />
    <div class="main-content">
      <SlimHeader />
      <div class="page-content">
        <router-view></router-view>
      </div>
    </div>
    <!-- Recordatorio semanal del formulario de incidentes (solo con sesión) -->
    <IncidentReminderDialog />
  </div>

  <!-- Timer global (badge + ventana flotante) - a propósito FUERA de los 3
       bloques de arriba (mantenimiento/auth/main), para que siga
       visible/corriendo incluso si se cierra la sesión (logout automático a
       las 8h, token vencido, etc.) - el intervalo que lo hace avanzar vive
       en el store (activeTimer.js), no en este componente, así que ya
       sobrevive solo a cualquier cambio de ruta; esto es solo para que el
       BADGE se siga viendo en la pantalla de login y no se pierda de vista
       mientras el usuario se vuelve a loguear para poder guardarlo (guardar
       requiere sesión válida - ver stopAndSave() en activeTimer.js). -->
  <GlobalTimerWidget />

</template>

<script setup>
import SidebarView from './components/layout/SidebarView.vue'
import SlimHeader from './components/layout/SlimHeader.vue'
import GlobalTimerWidget from './components/layout/GlobalTimerWidget.vue'
import IncidentReminderDialog from './components/ui/IncidentReminderDialog.vue'

import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const mantenimiento = false

// Detectar si estamos en la ruta de autenticación
const isAuthRoute = computed(() => route.path === '/auth')

//---- Localization
import esMessages from './diccionario/es.json'
import { locale, loadMessages } from "devextreme/localization";

onMounted(() => {
  loadMessages(esMessages)
  locale(navigator.language)
});


</script>

<style>

html {
  margin: 0;
}

body {
  font-family: var(--font-family);
  background: var(--srk-bg);
}

.main {
  height: 100svh;
  display: flex;
  flex-direction: row;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.page-content {
  flex: 1;
  overflow: auto;
  padding: var(--content-padding);
  min-height: 0;
}

.auth-container {
  height: 100svh;
  width: 100vw;
}
</style>
